import { ToWords } from 'to-words';
import { camelCase, mapKeys, isEmpty, sumBy } from 'lodash';
import 'jspdf-autotable';
import jsPDF from 'jspdf';
import swal from 'sweetalert';
import moment from 'moment';
import Spinner from "react-bootstrap/Spinner";
import './style.css';
import Logo from '../Images/logo.jpg';
// import { CleanNumber } from '../views/user_views/components/truncateText';


export const appendNonSignificantZeros = (id) => {
    if (Number(id) < 10 && Number(id) > 0) {
        return (id = `000${id}`);
    }
    if (Number(id) < 100 && Number(id) >= 10) {
        return (id = `00${id}`);
    }
    if (Number(id) < 1000 && Number(id) <= 100) {
        return (id = `0${id}`);
    }
    if (Number(id) >= 1000) {
        return (id);
    }
    return (id);
}

export const roundToTwoDecimals = (number = 0) => {
    return Math.round((Number(number) + Number.EPSILON) * 100) / 100;
}

export const handleNoDataVisible = () => {
    swal({
        title: "Warning",
        text: "No Data Found!",
        icon: "info",
        button: "Ok",
        timer: 6000,
    });
};

export const showSuccessAlert = (message) => {
    swal({
        title: "Success",
        text: message,
        icon: "success",
        button: "Ok",
        timer: 6000,
    });
};

export const showErrorAlert = (error) => {
    swal({
        title: "Error",
        text: error,
        icon: "error",
        button: "Ok",
        timer: 6000,
    });
};

export const handleDelete = (documentType) => {
    swal({
        title: "Are you sure?",
        text: "Do you want to delete this document ?",
        icon: "warning",
        buttons: true,
        dangerMode: true,
    }).then((willDelete) => {
        if (willDelete) {
            console.log("Delete document type:", documentType);
            // Add your delete API call here
        }
    });
};

export const startFinancialDate = "2025-07-01";
export const endFinancialDate = "2026-06-30";
export const FinancialYear = "2025 - 2026";

export function debugBase64(base64URL) {
    var win = window.open()
    if (win) win.document.write('<iframe src="' + base64URL + "_blank", '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>');
}

export function getVoucherName(id) {
    if (id == '1') return "Cash Payment Voucher"
    else if (id == '2') return "Cash Reciept Voucher"
    else if (id == '3') return "Bank Payment Voucher"
    else if (id == '4') return "Bank Reciept Voucher"
    else return "Journal Voucher"
}

export const previewVoucher = (data, status) => {
    const userName = window.localStorage.getItem("userName") || "User";
    const toWords = new ToWords();
    const doc = new jsPDF("portrait", "pt", "A4");
    PDFHeader(doc, "");

    doc.setFont("Times New Roman", "bold");
    doc.setFontSize(13);
    doc.text(getVoucherName(data.voucherTypeId), 230, 110);
    const voucherDate = `${data.vocDate} ${moment(data.createdAt).format('LT')}`;

    doc.setFont("Times New Roman", "Normal");
    doc.setFontSize(11);
    doc.text(`Voucher: ${data.voucherManualId}`, 40, 135);
    doc.text(`Voucher Status: ${status}`, 40, 150);
    doc.text(`Date: ${voucherDate}`, 40, 165);
    doc.text(`Amount In Word: ${toWords.convert(data.voucherData[0]?.voucherAmount)}`, 40, 180);

    // Cheque details (if applicable)
    if ([3, 4].includes(data.voucherTypeId)) {
        doc.text(`Cheque Number: ${data.voucherData[0]?.chequeNo || ''}`, 250, 135);
        doc.text(`Cheque Date: ${data.voucherData[0]?.chequeDate || ''}`, 250, 150);
    }

    // Prepare table data
    const headers = [["Account Name", "Bill", "Description", "Debit", "Credit"]];
    const headersSigned = [["Prepared By", "Approved By", "Audited By", "Received By"]];

    const tableData = data.voucherData.map(elt => [
        elt.accountTittle,
        elt.billNumber,
        elt.voucherDescription,
        elt.accountType == 2 ? Number(elt.voucherAmount) : 0,
        elt.accountType == 1 ? Number(elt.voucherAmount) : 0,
    ]);

    if (!isEmpty(tableData)) {
        tableData.push(["", "", "", `${sumBy(tableData, '3')}/-`, `${sumBy(tableData, '4')}/-`]);
    }

    // Render the main table
    doc.autoTable({
        startY: 195,
        startX: 5,
        head: headers,
        body: tableData,
        theme: 'grid',
        columnStyles: {
            0: { cellWidth: 160 },
            1: { cellWidth: 60 },
            2: { cellWidth: 180 },
            3: { cellWidth: 60 },
            4: { cellWidth: 60 },
        },
        headStyles: { fillColor: "#2980ba", fontSize: 10 },
        styles: { fontSize: 9 },
    });

    // Render signature section
    doc.autoTable({
        startY: doc.lastAutoTable.finalY + 10,
        startX: 5,
        head: headersSigned,
        body: [[
            { content: `${data?.userDetails?.userName || userName} - ${voucherDate}`, rowSpan: 5 },
            { content: `${data?.approvelUser?.userName || ''} - ${data?.voucherApprovelDate || ''}`, rowSpan: 5 },
            { content: '', rowSpan: 5 },
            { content: '', rowSpan: 5 }
        ]],
        theme: 'grid',
        headStyles: { fillColor: "#2980ba", fontSize: 10 },
        bodyStyles: { minCellHeight: 300 },
        styles: { fontSize: 9 },
    });

    doc.setProperties({ title: 'Voucher Print' });
    doc.autoPrint();
    doc.output('dataurlnewwindow');
}

export const camelizeKeys = (arr) => {
    let result = arr.map(el => mapKeys(el, (val, key) => camelCase(key)));
    return result;
};

export const changeDateFormate = (date) => {
    if (!date) return '';
    const d = new Date(date);
    if (isNaN(d)) return '';

    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();

    return `${day}-${month}-${year}`;
};

export function mergeNames(array, obj) {
    let output = [];
    for (let item of array) {
        output.push(`[${item[obj]}]`);
    }
    return output.toString()
}

export const PDFHeader = (doc, title = "Report") => {
    const pageWidth = doc.internal.pageSize.getWidth();

    const companyName = `${process.env.REACT_APP_COMPANY_NAME}`;
    const companyAddress = `${process.env.REACT_APP_COMPANY_ADDRESS}`;
    const companyNTN = `${process.env.REACT_APP_COMPANY_NTN}`;
    const companyPhone = `${process.env.REACT_APP_COMPANY_PHONE}`;

    // Add Logo (Top Left)
    const logoWidth = 80;
    const logoHeight = 60;
    doc.addImage(Logo, "JPG", 20, 40, logoWidth, logoHeight);

    // Print Date
    doc.setFontSize(9);
    doc.setFont("TimesNewRoman", "Normal");
    doc.text(`Print Date: ${moment().format('llll')}`, 10, 20);

    // Company Name
    doc.setFontSize(14);
    doc.setFont("TimesNewRoman", "bold");
    const companyNameWidth =
        doc.getStringUnitWidth(companyName) *
        doc.internal.getFontSize() /
        doc.internal.scaleFactor;

    doc.text(companyName, (pageWidth - companyNameWidth) / 2, 30);

    doc.setFontSize(12);
    doc.setFont("TimesNewRoman", "Normal");

    // Company Address
    const companyAddressWidth =
        doc.getStringUnitWidth(companyAddress) *
        doc.internal.getFontSize() /
        doc.internal.scaleFactor;

    doc.text(companyAddress, (pageWidth - companyAddressWidth) / 2, 45);

    // Company Phone
    const companyPhoneWidth =
        doc.getStringUnitWidth(companyPhone) *
        doc.internal.getFontSize() /
        doc.internal.scaleFactor;

    doc.text(companyPhone, (pageWidth - companyPhoneWidth) / 2, 60);

    // NTN
    const NTNPhoneWidth =
        doc.getStringUnitWidth(companyNTN) *
        doc.internal.getFontSize() /
        doc.internal.scaleFactor;

    doc.text(companyNTN, (pageWidth - NTNPhoneWidth) / 2, 75);

    // Report Title
    doc.setFontSize(15);
    doc.setFont("TimesNewRoman", "bold");
    doc.text(title, pageWidth / 2, 100, { align: "center" });

    return doc;
};

export function GlobalSpinner({ loading, text = "Please Wait..." }) {
    // if (!loading) return null;
    return (
        <div className="custom-loader-overlay">
            <div className="custom-loader-box">
                <Spinner animation="border" variant="light" className="custom-spinner" />
                {text && <p className="loader-text">{text}</p>}
            </div>
        </div>
    );

    // return (
    //     <div className="loader-overlay">
    //         <Spinner
    //             animation="border"
    //             variant="primary"
    //             style={{ width: "5rem", height: "5rem" }}
    //         />
    //     </div>
    // )

    // return (
    //     <div
    //         className="loader-div"
    //         style={{
    //             display: "flex",
    //             justifyContent: "center",
    //             alignItems: "center",
    //             height: "100vh",
    //         }}
    //     >
    //         <Spinner
    //             variant="primary"
    //             animation="border"
    //             role="status"
    //             aria-hidden="true"
    //             style={{ width: "3rem", height: "3rem" }}
    //         />
    //     </div>
    // );
}